// Module
var code = "<div id=\"msso-dialog-inner\"> <div id=\"msso-dialog-top\"> <span id=\"msso-dialog-close\">×</span> <div id=\"msso-dialog-title\"></div> </div> <div id=\"msso-dialog-content\"></div> </div> ";
// Exports
module.exports = code;